module.exports = __webpack_public_path__ + "static/media/footer_logo.d140dd78.png";